import { FormTable, FormTableBody, NearestRelativeFields } from "@porchpass/ui";
import { UserGroup02Icon } from "@porchpass/ui";
import * as React from "react";
import { useApplicationFormStore } from "../hooks/useApplicationFormStore";
import { validateNearestRelativeField } from "../utils/validationSchemas";

interface NearestRelativeFormProps {
  isCoBorrower?: boolean;
}

export const NearestRelativeForm: React.FC<NearestRelativeFormProps> = ({
  isCoBorrower = false,
}) => {
  const store = useApplicationFormStore();
  const borrower = isCoBorrower
    ? store.data.coBorrower
    : store.data.primaryBorrower;
  const updateBorrower = isCoBorrower
    ? store.updateCoBorrower
    : store.updatePrimaryBorrower;

  const borrowerPrefix = isCoBorrower ? "coBorrower" : "primaryBorrower";

  if (!borrower) return null;

  const clearIfValid = (field: string, value: string) => {
    const errorKey = `${borrowerPrefix}.${field}`;
    if (
      store.fieldErrors[errorKey] &&
      !validateNearestRelativeField(field, value)
    ) {
      store.clearFieldError(errorKey);
    }
  };

  const handleBorrowerChange = (patch: Partial<typeof borrower>) => {
    if (
      "nearestRelativeName" in patch &&
      patch.nearestRelativeName !== undefined
    ) {
      clearIfValid("nearestRelativeName", patch.nearestRelativeName);
    }
    if (
      "nearestRelativeRelationship" in patch &&
      patch.nearestRelativeRelationship !== undefined
    ) {
      clearIfValid(
        "nearestRelativeRelationship",
        patch.nearestRelativeRelationship,
      );
    }
    if (
      "nearestRelativePhone" in patch &&
      patch.nearestRelativePhone !== undefined
    ) {
      clearIfValid("nearestRelativePhone", patch.nearestRelativePhone);
    }
    updateBorrower(patch);
  };

  return (
    <FormTable
      title="Who is your nearest relative not living with you?"
      headerIcon={
        <UserGroup02Icon
          variant="bulk-rounded"
          size={16}
          className="text-primary"
        />
      }
    >
      <FormTableBody>
        <NearestRelativeFields
          value={{
            nearestRelativeName: borrower.nearestRelativeName,
            nearestRelativeRelationship: borrower.nearestRelativeRelationship,
            nearestRelativePhone: borrower.nearestRelativePhone,
          }}
          onChange={handleBorrowerChange}
          errors={{
            nearestRelativeName:
              store.fieldErrors[`${borrowerPrefix}.nearestRelativeName`],
            nearestRelativeRelationship:
              store.fieldErrors[
                `${borrowerPrefix}.nearestRelativeRelationship`
              ],
            nearestRelativePhone:
              store.fieldErrors[`${borrowerPrefix}.nearestRelativePhone`],
          }}
        />
      </FormTableBody>
    </FormTable>
  );
};

export default NearestRelativeForm;
